// TourGuide (2026-06) — server-side one-time onboarding flags.
import { apiClient as api } from "./client";

export async function patchTours(flags) {
  const { data } = await api.patch("/auth/me/tours", flags);
  return data;
}
